window.bootstrap = require( 'bootstrap' );
const { setupAlertBar } = require('./lib/alert-bar');
const { watchNavigation } = require('./lib/header');
const { watchLazyVideos } = require('./lib/lazy-video');
const { typeAheadSearch } = require('./lib/search');

document.addEventListener('DOMContentLoaded', () => {
	// Navivation functionality
	watchNavigation();

	// Image Rotator
	document.querySelectorAll('[data-image-rotator]').forEach((rotator) => {
		let imageItems = rotator.querySelectorAll('.image-item');
		let currentIndex = 0;
		let itemCount = imageItems.length;
		setInterval(() => {
			imageItems.forEach((item) => { item.classList.remove('show')});
			imageItems[currentIndex].classList.add('show');
			currentIndex = currentIndex == itemCount-1 ? 0 : currentIndex+1;
		}, 4000);
	});

	// Alert Bar
	setupAlertBar();

	// Lazy Load Videos
	watchLazyVideos();

	// Async Search results
	typeAheadSearch();
});